module.exports = __webpack_public_path__ + "static/img/75a4.232f4e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/75a4.jpg
// module id = 12hK
// module chunks = 1